<div class="textRecordsContainer">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
    <div class="loader" *ngIf="bodySpinner"></div>
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Create Template</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>
    </div>
     <div class="container-fluid">
        <div id="contractwrapper">
            <div class="row">
                <div class="col">Template Name</div>
                <div class="col"><input type="text" /></div>
            </div>
            <div class="row">
                <div class="col">Contract Type</div>
                <div class="col"><select><option>Select</option><option>NDA</option><option>ASA</option>
                <option>DPA</option><option>MSA</option><option>Exit</option><option>DSA</option><option>Indemnification</option></select></div>
            </div>
            <div class="row">
                <div class="col">Description</div>
                <div class="col"><textarea></textarea></div>
            </div>
            <div class="row">
                <div class="col"></div>
                <div class="col">
                       <label for="customFileUpload" class="custom-upload-button">
                        <span>Upload File</span>
                        <input type="file" id="customFileUpload" style="display: none;">
                        </label>
                
                </div>
            </div>
            <div class="row">
                <div class="col"></div>
                <div class="col"><button class="btn btn-primary audioTableSearchBtn">Save</button></div>
            </div>
        </div>
     </div>
</div>            